module.exports = __webpack_public_path__ + "static/media/b7.9b8b101.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penny/b7.mp3
// module id = 9eNO
// module chunks = 0